import type { Constraint } from '@htx/policies';

// ---------- Enums ----------
export enum PolicyType {
  ALWAYS_TRUE = 'ALWAYS_TRUE',
  PARTICIPANT_RESTRICTED = 'PARTICIPANT_RESTRICTED',
  TIME_PERIOD_RESTRICTED = 'TIME_PERIOD_RESTRICTED',
  MEMBERSHIP_STATIC = 'MEMBERSHIP_STATIC',
  USE_CASE_MEMBERSHIP = 'USE_CASE_MEMBERSHIP',
  FRAMEWORK_AGREEMENT = 'FRAMEWORK_AGREEMENT',
  END_DATE = 'END_DATE',
  COMPANY_REGION_RESTRICTED = 'COMPANY_REGION_RESTRICTED',
  DATACENTER_REGION_RESTRICTED = 'DATACENTER_REGION_RESTRICTED',
  UNKNOWN = 'UNKNOWN'
}

// ---------- Policy Role (CX-0152) ----------
export type PolicyRole = 'access' | 'usage';

// ---------- ODRL Action & Category ----------
export enum OdrlAction {
  USE = 'USE',
  ACCESS = 'ACCESS',
  TRANSFER = 'TRANSFER',
  DISTRIBUTE = 'DISTRIBUTE',
  READ = 'READ',
  MODIFY = 'MODIFY',
  DERIVE = 'DERIVE',
  AGGREGATE = 'AGGREGATE',
  ANONYMIZE = 'ANONYMIZE',
  DELETE = 'DELETE',
  REPRODUCE = 'REPRODUCE',
  DISPLAY = 'DISPLAY',
  ARCHIVE = 'ARCHIVE',
  EXTRACT = 'EXTRACT',
  COMPENSATE = 'COMPENSATE',
  UNKNOWN = 'UNKNOWN'
}

export enum OdrlCategory {
  PERMISSION = 'PERMISSION',
  PROHIBITION = 'PROHIBITION',
  OBLIGATION = 'OBLIGATION'
}

export interface OdrlRule {
  category: OdrlCategory;
  action: OdrlAction;
  actionRaw: string;
  constraints: Constraint[];
}

export function parseOdrlAction(raw: string): OdrlAction {
  const stripped = raw.replace(/^.*[#/:]/, '').toUpperCase();
  return (OdrlAction as Record<string, string>)[stripped] !== undefined
    ? (stripped as OdrlAction)
    : OdrlAction.UNKNOWN;
}

// ---------- Final Frontend-Policy ----------
export interface Policy {
  id: string;
  createdAt: number;
  constraints: Constraint[];
  rules?: OdrlRule[];
  prohibition: unknown[];
  obligation: unknown[];
  role?: PolicyRole;
  privateProperties?: {
    name: string;
    description: string;
  };
}
